// components/CountryFlag.js
import React from "react";

const CountryFlag = ({ code, width = 20, height = 20, alt }) => {
  if (!code) return null;

  const lower = code.toLowerCase();

  return (
    <img
      src={`https://flagcdn.com/${lower}.svg`}
      width={width}
      height={height}
      alt={alt || `${code} flag`}
      loading="lazy"
      style={{ display: "inline-block", objectFit: "cover" }}
    />
  );
};

export default CountryFlag;
